import { create } from 'zustand'

import type { ActionAgentOption } from '@/lib/workflowConfig'

interface ActionAgentsState {
  /** Agents the backend reports it accepts; null until a config answer has arrived. */
  agents: ActionAgentOption[] | null
  setAgents: (agents: ActionAgentOption[] | null) => void
}

/**
 * Backend-reported Action agents, filled from GET /workflows/config. The
 * inspector's Agent dropdown reads this instead of the frontend's catalog so a
 * frontend-first deploy cannot offer an id the running backend rejects.
 */
export const useActionAgentsStore = create<ActionAgentsState>()(set => ({
  agents: null,
  setAgents: agents => set({ agents }),
}))
